import { render } from "./asset-categories.vue?vue&type=template&id=88384cb8"
import script from "./asset-categories.vue?vue&type=script&lang=js"
export * from "./asset-categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__